import React from "react";

const Footer = ({ accommodationName }) => {
    return (
        <footer className="w-full footer border-t border-gray-200 py-6">
            <div className="w-full flex flex-col md:flex-row justify-between items-center gap-4 px-6 lg:px-10">
                <p className="text-sm text-white text-center md:text-left">
                    &copy; {new Date().getFullYear()} {accommodationName || ''}. All Rights Reserved.
                </p>
                <p className="text-sm text-white flex items-center gap-1 justify-center md:justify-end md:ml-auto">
                    <span className="opacity-80">Powered by</span>
                    <a
                        href="https://bookingwhizz.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="font-semibold underline underline-offset-2 hover:opacity-80 transition-opacity"
                    >
                        BookingWhizz
                    </a>
                    <span aria-hidden="true">⚡</span>
                </p>
            </div>
        </footer>
    );
};

export default Footer;